import { useSelector } from 'react-redux';
import { isBefore, subHours } from 'date-fns';
import useLocalStorage from '#/hooks/local-storage';
import { Side } from '@paradigm/features/src/unified-rfqs/entities/shared';
import { getUserID } from '@paradigm/store/src/auth/selectors';
import { Maybe } from '@paradigm/utils/types';

const STORED_QTY_KEY = 'um-grfq-stored-qty';

interface StoredQtyMap {
  [userId: number]: {
    [rfqId: number | string]: {
      SELL?: string;
      BUY?: string;
      timestamp?: number;
    };
  };
}

export function useRfqSideStoredQty(rfqId: number, side: Side) {
  const userId = useSelector(getUserID);
  const [storedQtyMap, setStoredQtyMap] = useLocalStorage<StoredQtyMap>(
    STORED_QTY_KEY,
    {},
  );

  const storedQty = storedQtyMap[userId]?.[rfqId]?.[side] ?? '';
  const setStoredQty = (value: string) => {
    setStoredQtyMap({
      ...storedQtyMap,
      [userId]: {
        ...clearUserOldStoredQty(storedQtyMap[userId]),
        [rfqId]: {
          ...storedQtyMap[userId]?.[rfqId],
          [side]: value,
          timestamp: Date.now(),
        },
      },
    });
  };

  return { storedQty, setStoredQty };
}

const QUANTITY_EXPIRATION_HOURS = 24;
function clearUserOldStoredQty(userStoredQty: Maybe<StoredQtyMap[number]>) {
  if (userStoredQty == null) return undefined;
  const cleanUserStoredQty: StoredQtyMap[number] = {};
  Object.entries(userStoredQty).forEach(([key, value]) => {
    if (
      value.timestamp == null ||
      isBefore(value.timestamp, subHours(Date.now(), QUANTITY_EXPIRATION_HOURS))
    )
      return;

    cleanUserStoredQty[key] = value;
  });

  return cleanUserStoredQty;
}
